export const roleTypes = {
  ADMIN: 'ADMIN',
  SUPER_ADMIN: 'SUPER_ADMIN',
  MAINTENANCE: 'MAINTENANCE',
  VIEWERS: 'VIEWERS',
};
